export default "/assets/images/dusty-taupe.webp?e474e72de1959cd54850f96f8e9d50e1";